"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--meterFillColor, #ADC6FA)",
  d: "M3 16.281c0-3.866 1.5-5.706 4-7l2.5 3.294-2.147 3.706H3Zm4-7.206c4-3.425 7.322-1.366 10-.5l-2.5 4.5-5-.5-2.5-3.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.852 16.5c0-3.866-1.852-6.206-4.352-7.5l-2 3.5 2 4h4.352Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.428 15.95H6.92a4.99 4.99 0 0 1 1.715-3.104L6.72 9.861a8.588 8.588 0 0 0-3.292 6.089Zm4.463-6.857L9.82 12.1c.46-.206.959-.343 1.481-.398v-1.627a.7.7 0 1 1 1.4 0v1.679c.495.09.964.253 1.396.48l2.013-3.14A8.562 8.562 0 0 0 12 8.05a8.562 8.562 0 0 0-4.109 1.043Zm9.389.768-2.046 3.191a4.986 4.986 0 0 1 1.487 2.898h3.85a8.588 8.588 0 0 0-3.291-6.09Zm-4.58 3.326a3.583 3.583 0 0 1 2.67 3.463.7.7 0 0 0 .7.7h5.23a.7.7 0 0 0 .7-.7c0-5.523-4.477-10-10-10s-10 4.477-10 10a.7.7 0 0 0 .7.7h4.87a.7.7 0 0 0 .7-.7 3.579 3.579 0 0 1 3.03-3.537v3.462a.7.7 0 1 0 1.4 0v-3.388Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterTwoIcon24.js.map